import React, { useEffect, useState } from "react";
import classes from "../../onboardingModule/styles/onboarding.module.css";
import { useReadOTP } from "react-read-otp";
import dynamic from "next/dynamic";
import { useMediaQuery } from "@mui/material";
const OTPInput = dynamic(() => import("otp-input-react"), {
  ssr: false
});
export default function OTPMODEL({
  verifyOTPHandler
}) {
  const [otp, setOtp] = useState("");

  //const [enabled, setEnabled] = useState(true);
  const smallScreen = useMediaQuery("(max-width:750px)");
  useReadOTP(setOtp);
  useEffect(() => {
    if (otp.length === 6) {
      verifyOTPHandler(otp);
    }
  }, [otp]);
  return <div className={classes.otpCont} data-sentry-component="OTPMODEL" data-sentry-source-file="otp.jsx">
      <OTPInput value={otp} onChange={otp_input => {
      setOtp(otp_input);
    }} autoFocus OTPLength={6} otpType="number" disabled={false} timeInterval={500} inputClassName={`${classes.otpBox1}`} style={{
      display: "flex",
      justifyContent: smallScreen ? "space-between" : "",
      alignItems: "center",
      gridTemplateColumns: "repeat(6, 1fr)",
      width: "100%",
      // height: "100%",
      marginLeft: smallScreen ? "" : "5px",
      marginBottom: "10px"
    }} data-sentry-element="OTPInput" data-sentry-source-file="otp.jsx" />
    </div>;
}